import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { applyStylesForScreenSize, SCREEN_SIZES } from 'brand-guidelines/utils/screenSizeUtils';
import { StepWrapper } from 'pages/checkout/components/common/layout-styled-components';

export const TreatmentsQuestionWrapper = styled(StepWrapper)`
  position: relative;
  max-width: 600px;

  && {
    .treatment-selector-option-block {
      .treatment-selector-option {
        width: 45%;

        label {
          width: auto;
        }
      }

      .treatment-checkup-cleaning {
        width: 100%;
      }
    }

    .treatment-selector-continue-button {
      position: initial;
      bottom: 0;
      background: none;
      transform: none;
    }

    .treatment-selector-other-treatment-note {
      margin-top: 16px;
    }
  }

  ${applyStylesForScreenSize([SCREEN_SIZES.PHONE, SCREEN_SIZES.TABLET], css`
    padding-bottom: 100px;

    && {
      .treatment-selector-option-block {
        display: grid;
        column-gap: 16px;
        row-gap: 12px;
        grid-template-columns: repeat(2, 1fr);
        grid-auto-rows: 1fr;

        .treatment-selector-option {
          width: auto;
          margin: 0;

          label {
            text-align: center;
            width: 100%;
            height: 100%;
          }
        }
      }

      .treatment-selector-option-block-ongoing-care {
        grid-template-columns: 1fr;
      }

      .treatment-selector-continue-button {
        position: fixed;
        bottom: 0;
        background: none;
        transform: translateX(-50%);

        background: ${BRAND_COLORS.white};
        border-top: 1px solid ${BRAND_COLORS.stroke};
        padding: 16px;
        display: flex;

        button {
          width: 100%;
        }
      }
    }
  `)}
`;
